
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { ResponsiveImage } from '@/components/ui/responsive-image';
import BlogPostContent from './BlogPostContent';

interface BlogPostContentProps {
  title: string;
  date: string;
  author: string;
  authorTitle: string;
  content: React.ReactNode;
  image: string;
  readTime: string;
  category: string;
}

const MobileFriendlyBlogPost: React.FC<BlogPostContentProps> = ({
  title,
  date,
  author,
  authorTitle,
  content,
  image,
  readTime,
  category
}) => {
  const isMobile = useIsMobile();
  
  return (
    <article className="max-w-4xl mx-auto">
      <div className="mb-6">
        <div className="text-sm text-itmgmt-medium-blue font-medium mb-2">
          {category} • {readTime}
        </div>
        <h1 className={`${isMobile ? 'text-2xl mb-4' : 'text-4xl mb-6'} font-bold text-itmgmt-dark-blue`}>
          {title}
        </h1>
        <div className="flex items-center mb-6">
          <div className="flex-shrink-0 mr-3">
            <div className="w-10 h-10 rounded-full bg-itmgmt-medium-blue text-white flex items-center justify-center font-bold">
              {author.split(' ').map(word => word[0]).join('')}
            </div>
          </div>
          <div>
            <p className="font-medium text-itmgmt-dark-blue">{author}</p>
            <p className="text-sm text-gray-600">{authorTitle} • {date}</p>
          </div>
        </div>
      </div>
      
      <div className="rounded-xl overflow-hidden mb-8">
        <ResponsiveImage
          src={image}
          alt={title}
          width={800}
          height={450}
          mobileWidth={400}
          aspectRatio={16/9}
          priority
        />
      </div>
      
      <div className={`blog-content ${isMobile ? 'px-4' : ''}`}>
        <BlogPostContent content={content} />
      </div>
      
      <div className={`mt-12 ${isMobile ? 'px-4' : ''}`}>
        <div className="border-t border-gray-200 pt-8">
          <h3 className="text-lg font-semibold mb-4">About the Author</h3>
          <div className="flex items-start">
            <div className="flex-shrink-0 mr-4">
              <div className="w-16 h-16 rounded-full bg-itmgmt-medium-blue text-white flex items-center justify-center text-xl font-bold">
                {author.split(' ').map(word => word[0]).join('')}
              </div>
            </div>
            <div>
              <p className="font-medium text-itmgmt-dark-blue text-lg">{author}</p>
              <p className="text-gray-600 mb-3">{authorTitle}</p>
              <p className="text-gray-700">
                IT Management Solutions expert sharing insights on technology best practices for small businesses.
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default MobileFriendlyBlogPost;
